import { useEffect } from "react";
import { useCookieConsent } from "../hooks/useCookieConsent";

const CLARITY_ID = "uypwunckel";

declare global {
  interface Window {
    clarity?: (...args: any[]) => void;
  }
}

export function Clarity() {
  const { hasMarketingConsent } = useCookieConsent();

  useEffect(() => {
    if (!hasMarketingConsent) {
      return;
    }

    // If already loaded, return early
    if (typeof window !== "undefined" && window.clarity) {
      return;
    }

    // Load Clarity script only after consent
    (function (c: any, l: any, a: any, r: any, i: any, t?: any, y?: any) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", CLARITY_ID);
  }, [hasMarketingConsent]);

  return null;
}
